import {Model} from '../../abstract/model';

export class ClientGroup extends Model {
  id: number;
  name: string;
}
